import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b0a1a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px","margin-left":"-12px","font-weight":"900","padding-left":"0px","color":"#606266"} }, "产品相关信息", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px","color":"#c43c07"} }, "（注意！报关资料中的产品名称、规格与计价单位应为工厂开票信息对应，请提前确认！）", -1))
const _hoisted_4 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-22px","color":"#606266"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "productTable"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "productHeader" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("产品中文名称 ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "productHeader" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("产品英文名称 ")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "productHeader"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"120px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("申报包装数量 ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"120px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("包装种类（英） ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "productHeader" }, " 产品规格/型号 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"110px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("成交数量 ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"110px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("计价单位 ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"80px"}
}, " 申报币制 ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("申报单价 ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("申报总价 ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("净重/KGS ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "* "),
  /*#__PURE__*/_createTextVNode("毛重/KGS ")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "productHeader",
  style: {"width":"115px"}
}, "体积/CBM", -1))
const _hoisted_21 = { class: "productData" }
const _hoisted_22 = { class: "link" }
const _hoisted_23 = { class: "productData" }
const _hoisted_24 = { class: "link" }
const _hoisted_25 = {
  key: 0,
  class: "productData"
}
const _hoisted_26 = { class: "productData" }
const _hoisted_27 = { class: "productData" }
const _hoisted_28 = { class: "link" }
const _hoisted_29 = { class: "productData" }
const _hoisted_30 = { class: "productData" }
const _hoisted_31 = { class: "productData" }
const _hoisted_32 = { class: "productData" }
const _hoisted_33 = { class: "productData" }
const _hoisted_34 = { class: "productData" }
const _hoisted_35 = { class: "productData" }
const _hoisted_36 = { class: "productData" }
const _hoisted_37 = { class: "productData" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "申报要素、监管信息及其他", -1))
const _hoisted_39 = { class: "link" }
const _hoisted_40 = { class: "link" }
const _hoisted_41 = { class: "link" }
const _hoisted_42 = { class: "link" }
const _hoisted_43 = { class: "reportTable" }
const _hoisted_44 = {
  key: 0,
  cellpadding: "0",
  cellspacing: "0"
}
const _hoisted_45 = { class: "left" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c75"} }, "*", -1))
const _hoisted_47 = { class: "right" }
const _hoisted_48 = { class: "link" }
const _hoisted_49 = {
  key: 1,
  cellpadding: "0",
  cellspacing: "0"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    class: "left",
    style: {"width":"100%","height":"30px","line-height":"30px","background-color":"#f5f7fa","color":"#caced5"}
  }, " 请先选择HS编码 ")
], -1))
const _hoisted_51 = [
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Search = _resolveComponent("Search")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_currency = _resolveComponent("miezz-currency")!
  const _component_miezz_hscode = _resolveComponent("miezz-hscode")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.visible) = $event)),
      "show-close": false,
      fullscreen: true,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_miezz_form, {
          ref: "ruleFormProduct",
          modelValue: _ctx.form,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form) = $event)),
          fix: true,
          key: _ctx.ruleFormRandom
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'ProductNameZh')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  "label-width": "0px"
                }, {
                  default: _withCtx(() => [
                    (item.Prop == 'ProductNameZh')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 24,
                                style: {"padding":"0px"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("table", _hoisted_6, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_7,
                                      _hoisted_8,
                                      (_ctx.isCustomsCode==true)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_9, " 海关代码 "))
                                        : _createCommentVNode("", true),
                                      _hoisted_10,
                                      _hoisted_11,
                                      _hoisted_12,
                                      _hoisted_13,
                                      _hoisted_14,
                                      _hoisted_15,
                                      _hoisted_16,
                                      _hoisted_17,
                                      _hoisted_18,
                                      _hoisted_19,
                                      _hoisted_20
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_21, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "ProductNameZh"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.form.Data.Type!=20 && _ctx.form.Data.Type!=30)
                                              ? (_openBlock(), _createBlock(_component_miezz_input, {
                                                  key: 0,
                                                  onHandleBlur: _ctx.onChangeProductNameZh,
                                                  modelValue: _ctx.form.Data.ProductNameZh,
                                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.ProductNameZh) = $event)),
                                                  placeholder: '请填写'
                                                }, null, 8, ["onHandleBlur", "modelValue"]))
                                              : (_openBlock(), _createBlock(_component_el_autocomplete, {
                                                  key: 1,
                                                  modelValue: _ctx.form.Data.ProductNameZh,
                                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.ProductNameZh) = $event)),
                                                  clearable: false,
                                                  style: {"width":"100% !important"},
                                                  "fetch-suggestions": _ctx.querySearchProductNameZhAsync,
                                                  "popper-class": "my-autocomplete",
                                                  placeholder: "请选择",
                                                  onSelect: _ctx.handleSelectProductNameZe,
                                                  onChange: _ctx.onChangeProductNameZh
                                                }, {
                                                  default: _withCtx(({ item }) => [
                                                    _createElementVNode("span", _hoisted_22, _toDisplayString(item.Label), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange"]))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("td", _hoisted_23, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "ProductNameEn"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.form.Data.Type!=20 && _ctx.form.Data.Type!=30)
                                              ? (_openBlock(), _createBlock(_component_miezz_input, {
                                                  key: 0,
                                                  onHandleBlur: _ctx.onChangeProductNameEn,
                                                  trim: false,
                                                  modelValue: _ctx.form.Data.ProductNameEn,
                                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.ProductNameEn) = $event)),
                                                  placeholder: '请填写'
                                                }, null, 8, ["onHandleBlur", "modelValue"]))
                                              : (_openBlock(), _createBlock(_component_el_autocomplete, {
                                                  key: 1,
                                                  modelValue: _ctx.form.Data.ProductNameEn,
                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.ProductNameEn) = $event)),
                                                  clearable: false,
                                                  style: {"width":"100% !important"},
                                                  "fetch-suggestions": _ctx.querySearchProductNameEnAsync,
                                                  "popper-class": "my-autocomplete",
                                                  placeholder: "请选择",
                                                  onSelect: _ctx.handleSelectProductNameEn,
                                                  onChange: _ctx.onChangeProductNameEn
                                                }, {
                                                  default: _withCtx(({ item }) => [
                                                    _createElementVNode("span", _hoisted_24, _toDisplayString(item.Label), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange"]))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      (_ctx.isCustomsCode==true)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                                            _createVNode(_component_el_form_item, {
                                              "label-width": "0px",
                                              prop: "CustomsCode"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_miezz_input, {
                                                  trim: false,
                                                  modelValue: _ctx.form.Data.CustomsCode,
                                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.CustomsCode) = $event)),
                                                  placeholder: '请填写'
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("td", _hoisted_26, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "PackageQuantity"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: _ctx.form.Data.PackageQuantity,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.PackageQuantity) = $event)),
                                              onHandleBlur: _ctx.onChangePackageQuantity,
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue", "onHandleBlur"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_27, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "PackageName"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_autocomplete, {
                                              modelValue: _ctx.form.Data.PackageName,
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.PackageName) = $event)),
                                              clearable: false,
                                              "fetch-suggestions": _ctx.querySearchPackageNameAsync,
                                              "popper-class": "my-autocomplete",
                                              placeholder: "请选择",
                                              onSelect: _ctx.handleSelectPackageName
                                            }, {
                                              default: _withCtx(({ item }) => [
                                                _createElementVNode("span", _hoisted_28, _toDisplayString(item.Label), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "fetch-suggestions", "onSelect"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("td", _hoisted_29, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "SpecName"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              trim: false,
                                              modelValue: _ctx.form.Data.SpecName,
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.SpecName) = $event)),
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_30, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "TransactionQuantity"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: _ctx.form.Data.TransactionQuantity,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Data.TransactionQuantity) = $event)),
                                              onHandleBlur: _ctx.onChangeTransactionQuantity,
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue", "onHandleBlur"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_31, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "ChargeUnit"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_select, {
                                              clearable: false,
                                              modelValue: _ctx.form.Data.ChargeUnit,
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.ChargeUnit) = $event)),
                                              options: _ctx.chargeUnits,
                                              onHandleChange: _ctx.onChangeChargeUnit,
                                              valueKey: "Label",
                                              labelKey: "Label",
                                              style: {"width":"100% !important"},
                                              placeholder: '请选择'
                                            }, null, 8, ["modelValue", "options", "onHandleChange"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_32, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "CurrencySystemId"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: {"text-decoration":"underline","color":"#fe995b","cursor":"pointer","padding-left":"20px"},
                                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onCurrency && _ctx.onCurrency(...args)))
                                            }, _toDisplayString(_ctx.form.Data.CurrencySystemName), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_33, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "UnitPrice"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: _ctx.form.Data.UnitPrice,
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.Data.UnitPrice) = $event)),
                                              onHandleBlur: _ctx.onChangeUnitPrice,
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue", "onHandleBlur"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_34, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "TotalPrice"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: _ctx.form.Data.TotalPrice,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.TotalPrice) = $event)),
                                              onHandleBlur: _ctx.onChangeTotalPrice,
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue", "onHandleBlur"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_35, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "NetWeight"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: _ctx.form.Data.NetWeight,
                                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.NetWeight) = $event)),
                                              onHandleBlur: _ctx.onChangeNetWeight,
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue", "onHandleBlur"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_36, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "GrossWeight"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: _ctx.form.Data.GrossWeight,
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.Data.GrossWeight) = $event)),
                                              onHandleBlur: _ctx.onChangeGrossWeight,
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue", "onHandleBlur"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("td", _hoisted_37, [
                                        _createVNode(_component_el_form_item, {
                                          "label-width": "0px",
                                          prop: "Volume"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_miezz_input, {
                                              modelValue: _ctx.form.Data.Volume,
                                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.Data.Volume) = $event)),
                                              onHandleBlur: _ctx.onChangeVolume,
                                              placeholder: '请填写'
                                            }, null, 8, ["modelValue", "onHandleBlur"])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 24,
                                style: {"padding":"0px"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_38
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "HS编码",
                                    "label-width": "200px",
                                    prop: "HsCode"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        placeholder: "请选择",
                                        modelValue: _ctx.form.Data.HsCode,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.Data.HsCode) = $event)),
                                        class: "input-with-select",
                                        style: {"cursor":"pointer"},
                                        onClick: _ctx.onHsCode
                                      }, {
                                        append: _withCtx(() => [
                                          _createElementVNode("div", {
                                            style: {"padding":"0px","text-align":"center","margin":"0px","cursor":"pointer"},
                                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onHsCode && _ctx.onHsCode(...args)))
                                          }, [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Search)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "退税率",
                                    "label-width": "200px",
                                    prop: "TaxRate"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        modelValue: _ctx.form.Data.TaxRate,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.Data.TaxRate) = $event)),
                                        disabled: true,
                                        placeholder: '请先选择HS编码'
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  (_ctx.form.Data.HsCode!=undefined && _ctx.form.Data.HsCode!='')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 0,
                                        label: '法定第一计量单位' + '（'  + _ctx.form.Data.StatutoryFirstUnit + '）',
                                        "label-width": "200px",
                                        prop: "StatutoryFirstUnitValue"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            modelValue: _ctx.form.Data.StatutoryFirstUnitValue,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.Data.StatutoryFirstUnitValue) = $event)),
                                            onHandleBlur: _ctx.onChangeStatutoryFirstUnitValue
                                          }, null, 8, ["modelValue", "onHandleBlur"])
                                        ]),
                                        _: 1
                                      }, 8, ["label"]))
                                    : (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 1,
                                        label: "法定第一计量单位",
                                        "label-width": "200px",
                                        prop: "StatutoryFirstUnitValue"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            disabled: true,
                                            modelValue: _ctx.form.Data.StatutoryFirstUnitValue,
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.StatutoryFirstUnitValue) = $event)),
                                            placeholder: '请先选择HS编码'
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  (_ctx.form.Data.HsCode!=undefined && _ctx.form.Data.HsCode!='')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 0,
                                        label: '法定第二计量单位' + '（'  + _ctx.form.Data.StatutorySecondUnit + '）',
                                        "label-width": "200px",
                                        prop: _ctx.form.Data.StatutorySecondUnit=='无'?'':'StatutorySecondUnitValue'
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            disabled: _ctx.form.Data.StatutorySecondUnit=='无'?true:false,
                                            modelValue: _ctx.form.Data.StatutorySecondUnitValue,
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.Data.StatutorySecondUnitValue) = $event)),
                                            onHandleBlur: _ctx.onChangeStatutorySecondUnitValue
                                          }, null, 8, ["disabled", "modelValue", "onHandleBlur"])
                                        ]),
                                        _: 1
                                      }, 8, ["label", "prop"]))
                                    : (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 1,
                                        label: "法定第二计量单位",
                                        "label-width": "200px",
                                        prop: _ctx.form.Data.StatutorySecondUnit=='无'?'':'StatutorySecondUnitValue'
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            disabled: true,
                                            modelValue: _ctx.form.Data.StatutorySecondUnitValue,
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.Data.StatutorySecondUnitValue) = $event)),
                                            placeholder: '请先选择HS编码'
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }, 8, ["prop"]))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "征免方式",
                                    "label-width": "200px",
                                    prop: "ExemptingModeId"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_select, {
                                        clearable: false,
                                        modelValue: _ctx.form.Data.ExemptingModeId,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.Data.ExemptingModeId) = $event)),
                                        options: _ctx.exemptingModes,
                                        onHandleChange: _ctx.onChangeExemptingModeId,
                                        valueKey: "Value",
                                        labelKey: "Label",
                                        style: {"width":"100% !important"}
                                      }, null, 8, ["modelValue", "options", "onHandleChange"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "最终目的国（地区）",
                                    "label-width": "200px",
                                    prop: "FinanCountryId"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_autocomplete, {
                                        modelValue: _ctx.form.Data.FinanCountryName,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.Data.FinanCountryName) = $event)),
                                        clearable: false,
                                        "fetch-suggestions": _ctx.querySearchFinanCountryIdAsync,
                                        "popper-class": "my-autocomplete",
                                        placeholder: "请填写关键词",
                                        onSelect: _ctx.handleSelectFinanCountryId,
                                        onChange: _ctx.onChangeFinanCountryId,
                                        onClear: _ctx.onChangeFinanCountryId
                                      }, {
                                        default: _withCtx(({ item }) => [
                                          _createElementVNode("span", _hoisted_39, _toDisplayString(item.Label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "原产国（地区）",
                                    "label-width": "200px",
                                    prop: "OriginCountryId"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_autocomplete, {
                                        modelValue: _ctx.form.Data.OriginCountryName,
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.Data.OriginCountryName) = $event)),
                                        clearable: false,
                                        "fetch-suggestions": _ctx.querySearchOriginCountryIdAsync,
                                        "popper-class": "my-autocomplete",
                                        placeholder: "请填写关键词",
                                        onSelect: _ctx.handleSelectOriginCountryId,
                                        onChange: _ctx.onChangeOriginCountryId,
                                        onClear: _ctx.onChangeOriginCountryId
                                      }, {
                                        default: _withCtx(({ item }) => [
                                          _createElementVNode("span", _hoisted_40, _toDisplayString(item.Label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 7 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "境内货源地",
                                    "label-width": "200px",
                                    prop: "DomesticGoodsPlaceId"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_autocomplete, {
                                        modelValue: _ctx.form.Data.DomesticGoodsPlaceName,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.Data.DomesticGoodsPlaceName) = $event)),
                                        clearable: false,
                                        "fetch-suggestions": _ctx.querySearchDomesticGoodsPlaceIdAsync,
                                        "popper-class": "my-autocomplete",
                                        placeholder: "请填写关键词",
                                        onSelect: _ctx.handleSelectDomesticGoodsPlaceId,
                                        onChange: _ctx.onChangeDomesticGoodsPlaceId,
                                        onClear: _ctx.onChangeDomesticGoodsPlaceId
                                      }, {
                                        default: _withCtx(({ item }) => [
                                          _createElementVNode("span", _hoisted_41, _toDisplayString(item.Label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "详细地址",
                                    "label-width": "100px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_autocomplete, {
                                        modelValue: _ctx.form.Data.PlaceName,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.Data.PlaceName) = $event)),
                                        clearable: true,
                                        "fetch-suggestions": _ctx.querySearchPlaceIdAsync,
                                        "popper-class": "my-autocomplete",
                                        placeholder: "请填写关键词",
                                        onSelect: _ctx.handleSelectPlaceId,
                                        onChange: _ctx.onChangePlaceId,
                                        onClear: _ctx.onChangePlaceId
                                      }, {
                                        default: _withCtx(({ item }) => [
                                          _createElementVNode("span", _hoisted_42, _toDisplayString(item.Label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "备案序号",
                                    "label-width": "200px",
                                    prop: "RecordOrder"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        trim: false,
                                        modelValue: _ctx.form.Data.RecordOrder,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.Data.RecordOrder) = $event)),
                                        placeholder: '请填写'
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "监管条件/监管代码",
                                    "label-width": "200px",
                                    prop: "SupervisionConditionsCode"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        modelValue: _ctx.form.Data.SupervisionConditionsCode,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.Data.SupervisionConditionsCode) = $event)),
                                        disabled: true,
                                        placeholder: '请先选择HS编码'
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "申报要素",
                                    "label-width": "200px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_43, [
                                        (_ctx.form.Data.ProductElements!=null && _ctx.form.Data.ProductElements.length>0)
                                          ? (_openBlock(), _createElementBlock("table", _hoisted_44, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.ProductElements, (p, index) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                  _createElementVNode("td", _hoisted_45, [
                                                    _hoisted_46,
                                                    _createTextVNode(_toDisplayString(p.Name), 1)
                                                  ]),
                                                  _createElementVNode("td", _hoisted_47, [
                                                    _createVNode(_component_el_form_item, {
                                                      label: "",
                                                      "label-width": "10px",
                                                      style: {"padding-top":"10px"},
                                                      prop: `ProductElements[${index}].Value`,
                                                      rules: _ctx.form.Rules.ProductElements_Value
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (p.Name.indexOf('品牌类型')>=0)
                                                          ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                              key: 0,
                                                              clearable: false,
                                                              modelValue: p.Value,
                                                              "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                                                              options: _ctx.brands,
                                                              onHandleChange: ($event: any) => (_ctx.onChangeBrand(index)),
                                                              valueKey: "Label",
                                                              labelKey: "Label",
                                                              style: {"width":"100% !important"}
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onHandleChange"]))
                                                          : (p.Name.indexOf('出口享惠情况')>=0)
                                                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                                key: 1,
                                                                clearable: false,
                                                                modelValue: p.Value,
                                                                "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                                                                options: _ctx.exports,
                                                                onHandleChange: ($event: any) => (_ctx.onChangeExport(index)),
                                                                valueKey: "Label",
                                                                labelKey: "Label",
                                                                style: {"width":"100% !important"}
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onHandleChange"]))
                                                            : (p.Values!=null && p.Values.length>0)
                                                              ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                                                                  key: 2,
                                                                  modelValue: p.Value,
                                                                  "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                                                                  clearable: false,
                                                                  "fetch-suggestions": _ctx.querySearchElement,
                                                                  "popper-class": "my-autocomplete",
                                                                  placeholder: "请填写关键词",
                                                                  onSelect: _ctx.handleSelectElement,
                                                                  onFocus: ($event: any) => (_ctx.onAddRecommend(p.Values,index))
                                                                }, {
                                                                  default: _withCtx(({ item }) => [
                                                                    _createElementVNode("span", _hoisted_48, _toDisplayString(item), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect", "onFocus"]))
                                                              : (_openBlock(), _createBlock(_component_miezz_input, {
                                                                  key: 3,
                                                                  trim: false,
                                                                  modelValue: p.Value,
                                                                  "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                                                                  placeholder: '请填写'
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["prop", "rules"])
                                                  ])
                                                ]))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("table", _hoisted_49, _hoisted_51))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])),
        _createVNode(_component_miezz_currency, {
          isRate: false,
          defaultCurrency: '美元',
          ref: "Currency",
          onOnSelectCurrency: _ctx.onSelectCurrency
        }, null, 8, ["onOnSelectCurrency"]),
        _createVNode(_component_miezz_hscode, {
          ref: "HsCode",
          onOnSelectHsCode: _ctx.onSelectHsCode
        }, null, 8, ["onOnSelectHsCode"]),
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.bottomButtons,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.bottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClick
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}